import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '@material-ui/core';

import { t } from '~/helpers';
import { recordFiltering } from '~/store/modules/operacaoRecebimentoNf/actions';

import { Form } from '..';

export default function Heading() {
  const dispatch = useDispatch();

  const [modal, setModal] = React.useState(false);

  const tabsRef = React.useRef(null);

  const { params } = useSelector((state) => state.operacaoRecebimentoNf);

  // open Modal Tabs
  const handleOpenTabs = React.useCallback(() => {
    setModal(true);
  }, []);

  // close Modal Tabs
  const handleCloseModal = React.useCallback(() => {
    setModal(false);
    dispatch(recordFiltering(params));
  }, [params]);

  React.useEffect(() => {
    if (modal) tabsRef.current.openModal();
  }, [modal]);

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={handleOpenTabs}
      >
        {t('s.geral.botaoincluir')}
      </Button>

      {modal && <Form ref={tabsRef} onCloseModal={handleCloseModal} />}
    </>
  );
}
